/* Desktop mega-menu dismissal; mobile navigation remains theme-managed. */
(() => {
  'use strict';
  if (window.lmpDesktopMenuBound) return;
  window.lmpDesktopMenuBound = true;
  const desktop = window.matchMedia('(min-width: 1001px)');
  const navSelector = ':is(#nav, #nav-bar).mega';
  const itemSelector = `${navSelector} > ul > li:has(> ul.wide)`;
  const items = () => [...document.querySelectorAll(itemSelector)];
  const trigger = item => item.querySelector(':scope > a[accesskey], :scope > a:not(.toggle)');
  const panel = item => item.querySelector(':scope > ul.wide');

  function dismiss(item) {
    item.setAttribute('data-lmp-menu-dismissed', '');
    item.classList.remove('hover', 'toggle');
    item.setAttribute('aria-expanded', 'false');
    trigger(item)?.setAttribute('aria-expanded', 'false');
  }

  function reopen(item) {
    item.removeAttribute('data-lmp-menu-dismissed');
    trigger(item)?.setAttribute('aria-expanded', 'true');
  }

  document.addEventListener('pointerover', event => {
    if (!desktop.matches || !(event.target instanceof Element)) return;
    const item = event.target.closest(itemSelector);
    if (item && !item.contains(event.relatedTarget)) reopen(item);
  });

  document.addEventListener('focusin', event => {
    if (!desktop.matches || !(event.target instanceof Element)) return;
    const item = event.target.closest(itemSelector);
    if (item && !item.contains(event.relatedTarget)) reopen(item);
  });

  document.addEventListener('pointerdown', event => {
    if (!desktop.matches || !(event.target instanceof Element) || event.target.closest(navSelector)) return;
    const active = document.activeElement;
    if (active instanceof HTMLElement && active.closest(navSelector)) active.blur();
    items().forEach(dismiss);
    document.documentElement.classList.remove('nav-hover');
  }, true);

  document.addEventListener('keydown', event => {
    if (!desktop.matches) return;
    const active = document.activeElement;
    const item = active instanceof Element ? active.closest(itemSelector) : null;
    if (event.key === 'Escape') {
      const open = items().filter(entry => getComputedStyle(panel(entry)).visibility === 'visible');
      if (!open.length) return;
      event.preventDefault();
      const owner = item || open[0];
      trigger(owner)?.focus({ preventScroll: true });
      items().forEach(dismiss);
      document.documentElement.classList.remove('nav-hover');
    } else if (event.key === 'ArrowDown' && item && active === trigger(item)) {
      event.preventDefault();
      reopen(item);
      panel(item).querySelector('a:not(.toggle)')?.focus({ preventScroll: true });
    }
  });

  desktop.addEventListener('change', () => {
    items().forEach(item => {
      item.removeAttribute('data-lmp-menu-dismissed');
      trigger(item)?.removeAttribute('aria-expanded');
    });
  });
})();
